<template>
  <div
    :data-qa-id="option.delivery_type"
    class="form-address-wrap"
  >
    <CalculatorFormAddressItem
      v-if="option.showSender"
      :address-home="option.sender.addressHome"
      :address-street="option.sender.addressStreet"
      :address-zip="option.sender.addressZip"
      :city-name="orderCalcPIP.sender.cityName"
      :address-default="addressDefaultSender"
      @addressHomeChanged="$emit('addressHomeSenderChanged', $event)"
      @addressStreetChanged="$emit('addressStreetSenderChanged', $event)"
      @addressZipChanged="$emit('addressZipSenderChanged', $event)"
      @addressAllChanged="$emit('addressAllSenderChanged', $event)"
      @forceSubmit="onSubmitClick"
    >
      <template slot="text">
        <div class="calculator-field__label">
          Адрес отправителя
        </div>
      </template>
    </CalculatorFormAddressItem>
    <CalculatorFormAddressItem
      v-if="option.showReceiver"
      :address-home="option.receiver.addressHome"
      :address-street="option.receiver.addressStreet"
      :address-zip="option.receiver.addressZip"
      :city-name="orderCalcPIP.receiver.cityName"
      :address-default="addressDefaultReceiver"
      @addressHomeChanged="$emit('addressHomeReceiverChanged', $event)"
      @addressStreetChanged="$emit('addressStreetReceiverChanged', $event)"
      @addressZipChanged="$emit('addressZipReceiverChanged', $event)"
      @addressAllChanged="$emit('addressAllReceiverChanged', $event)"
      @forceSubmit="onSubmitClick"
    >
      <template slot="text">
        <div class="calculator-field__label">
          Адрес получателя
        </div>
      </template>
    </CalculatorFormAddressItem>

    <a
      class="calculator__button calculator__button_green ms-auto form-address__btn2"
      :class="{
        'calculator__button_loading': isLoading,
        'calculator__button_disabled': !isValid
      }"
      @click="onSubmitClick"
    >
      <span>Рассчитать</span>
    </a>
  </div>
</template>

<script>
import { calculateZip } from '../../models/calculator-pip';
import CalculatorFormAddressItem from './CalculatorFormAddressItem.vue';

export default {
  name: 'CalculatorFormAddress',
  components: { CalculatorFormAddressItem },
  props: {
    option: {
      type: Object,
      required: true,
    },
    orderCalcPIP: {
      type: Object,
      required: true,
    },
    errorDictionary: {
      type: Object,
      required: true,
    },
    addressDefaultSender: {
      type: Object,
      default: () => ({}),
    },
    addressDefaultReceiver: {
      type: Object,
      default: () => ({}),
    },
    salePip: {
      type: Boolean,
      default: false,
    },
    calcImport: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    isValid() {
      return !(this.option.showReceiver && !this.option.receiver.addressZip)
        && !(this.option.showSender && !this.option.sender.addressZip);
    },
  },
  methods: {
    onSubmitClick() {
      this.isLoading = true;
      let targetName;

      switch (this.option.delivery_type) {
        case 2: targetName = 'kz';
          break;
        case 3: targetName = 'kd';
          break;
        case 1: targetName = 'kz_kd';
          break;
        default:
          break;
      }
      document.dispatchEvent(new CustomEvent('reachGoal', { detail: { targetName } }));

      calculateZip(this.orderCalcPIP, this.errorDictionary, this.option.sender.addressZip,
        this.option.receiver.addressZip, this.option.delivery_type, this.salePip, this.calcImport)
        .then((deliveryOptions) => {
          const deliveryOptionsByType = deliveryOptions.find((delivery) => delivery.delivery_type === this.option.delivery_type);
          this.$emit('updateDataByType', deliveryOptionsByType);
          this.$emit('changeShowPrice', true);
          this.$emit('changeZipSuccess', true);
          this.$emit('changeZipSenderError', false);
          this.$emit('changeZipReceiverError', false);
          this.saveDefaultAddress();
        })
        .catch((errArr) => {
          this.$emit('error', errArr.message);
          this.$emit('changeShowPrice', false);
          this.$emit('changeZipSuccess', false);
          this.$emit('changeZipSenderError', true);
          this.$emit('changeZipReceiverError', true);
        })
        .finally(() => {
          this.isLoading = false;
          this.$emit('closeForm');
        });
    },
    saveDefaultAddress() {
      if (this.option.sender.addressZip) {
        const addressDefaultSender = {
          addressStreet: this.option.sender.addressStreet,
          addressHome: this.option.sender.addressHome,
          addressZip: this.option.sender.addressZip,
          addressAll: this.option.sender.addressAll,
        };
        this.$emit('changeDefaultAddressSender', addressDefaultSender);
      }
      if (this.option.receiver.addressZip) {
        const addressDefaultReceiver = {
          addressStreet: this.option.receiver.addressStreet,
          addressHome: this.option.receiver.addressHome,
          addressZip: this.option.receiver.addressZip,
          addressAll: this.option.receiver.addressAll,
        };
        this.$emit('changeDefaultAddressReceiver', addressDefaultReceiver);
      }
    },
  },
};
</script>
